var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Email.RegisterPicVerifyGet",
    "options": {
        "objc_class_prefix": "EmailRegisterPicVerifyGet",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "verifyCode",
                    "id": 1
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "result",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "REASON",
                    "name": "reason",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "verifyCode",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "picData",
                    "id": 4
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "REASON",
            "values": [
                {
                    "name": "DEFAULT",
                    "id": 0
                },
                {
                    "name": "OK",
                    "id": 1
                },
                {
                    "name": "CHECK_CLOSED",
                    "id": 2
                },
                {
                    "name": "NOVEROFYCODE",
                    "id": 3
                },
                {
                    "name": "UNKONOW",
                    "id": 100
                }
            ]
        }
    ]
}).build();
export default _root;



// WEBPACK FOOTER //
// ./js/services/protos/captcha-info.pb.js